import React, { useState, useEffect } from 'react';
import './index.css';
import clsx from 'classnames';
import { useNewsList, usePageTitle } from '../../hooks';
import TweenOne from 'rc-tween-one';
import { useAppContext } from 'context';
import Pagination from '../../components/Pagination';
import { useHistory } from 'react-router-dom';
import QueueAnim from 'rc-queue-anim';
import { Loading } from 'components';
import { isEmpty } from '../../utils/utils';
import Empty from '../../components/Empty';

const News = () => {
  // 设置页面标题
  usePageTitle('新闻动态');
  const [list, setList] = useState([]);
  const history = useHistory();
  const [firstNews, setFirstNews] = useState({});
  const [firstNewsImg, setFirstNewsImg] = useState('');
  const {
    state: { newsCurrentPage },
    dispatch,
  } = useAppContext();

  // 获取产品列表数据
  const { data, loading, refresh } = useNewsList(
    {
      pageNo: newsCurrentPage,
      pageSize: 10,
    },
    { immediate: false },
  );

  const totalCount = data?.totalCount;

  useEffect(() => {
    if (!loading && !isEmpty(data?.list)) {
      setList(data?.list);
      setFirstNews(data?.list[0]);
      setFirstNewsImg(
        'http://offical-php.zjzyfwq.com/uploads/' +
          data?.list[0].cover[0]?.filename,
      );
    }
  }, [loading, data]);

  // 去除字符串时间的时分秒
  const formatTime = (time) => {
    return time?.split(' ')[0];
  };

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newsCurrentPage]);

  // 根据peoductArr数据进行数据重组已10条数据为一页，返回重组数组以及相关的页数
  const totalPages = Math.ceil(totalCount / 10);

  // 一开始只显示四个新闻
  const newList = list?.slice(1);
  // 展示新闻列表
  const newList3 = newList?.slice(0, 9);

  const onClick = (id) => {
    history.push(`/news/${id}`);
  };

  return (
    <div className={clsx('news-top')} style={{ minHeight: window.innerHeight }}>
      {/* 顶部Banner */}
      <TweenOne
        className={clsx('news-banner')}
        animation={{ y: 30, opacity: 0, type: 'from' }}
      >
        新闻动态
      </TweenOne>
      {/* 新闻内容 */}
      {!loading ? (
        !isEmpty(list) ? (
          <QueueAnim className={clsx('news-content')} type={['right', 'left']}>
            {!loading
              ? [
                  //  首个新闻
                  <div
                    className={clsx('news-first-item')}
                    onClick={() => onClick(firstNews.id)}
                    key='news-first-item'
                  >
                    <TweenOne
                      className={clsx('news-first-item-imgBlock')}
                      animation={{ x: -50, opacity: 0, type: 'from' }}
                    >
                      <img
                        src={firstNewsImg}
                        alt={firstNews?.title}
                        width='100%'
                        height='100%'
                        className={clsx('news-first-item-img')}
                      />
                    </TweenOne>
                    <TweenOne
                      className={clsx('news-first-item-content')}
                      animation={{ x: 50, opacity: 0, type: 'from' }}
                    >
                      <div className={clsx('news-first-item-content-text')}>
                        {firstNews?.title}
                      </div>
                      <div className={clsx('news-first-item-content-time')}>
                        {formatTime(firstNews?.add_time)}
                      </div>
                    </TweenOne>
                  </div>,
                  // 小屏首个新闻
                  <div
                    className={clsx('news-list-first-item')}
                    key='news-list-first-item'
                    onClick={() => onClick(firstNews.id)}
                  >
                    <div className={clsx('news-list-item-imgBlock')}>
                      <img
                        src={firstNewsImg}
                        alt={firstNews?.title}
                        width='100%'
                        height='100%'
                        className={clsx('news-list-item-img')}
                      />
                    </div>
                    <div className={clsx('news-list-item-content')}>
                      <div className={clsx('news-list-item-content-text')}>
                        {firstNews?.title}
                      </div>
                      <div className={clsx('news-list-item-content-time')}>
                        {formatTime(firstNews?.add_time)}
                      </div>
                    </div>
                  </div>,
                  //  新闻列表
                  <div className={clsx('news-list')} key='news-list'>
                    {newList3?.map((item) => {
                      const imgUrl =
                        'http://offical-php.zjzyfwq.com/uploads/' +
                        item.cover[0]?.filename;
                      return (
                        <div
                          className={clsx('news-list-item')}
                          key={item.id}
                          onClick={() => onClick(item.id)}
                        >
                          <div className={clsx('news-list-item-imgBlock')}>
                            <img
                              src={imgUrl}
                              alt={item.title}
                              width='100%'
                              height='100%'
                              className={clsx('news-list-item-img')}
                            />
                          </div>
                          <div className={clsx('news-list-item-content')}>
                            <div
                              className={clsx('news-list-item-content-text')}
                            >
                              {item.title}
                            </div>
                            <div
                              className={clsx('news-list-item-content-time')}
                            >
                              {formatTime(item.add_time)}
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>,
                  <div key='pagination'>
                    <Pagination
                      totalPages={totalPages}
                      currentPage={newsCurrentPage}
                      onChange={(page) => {
                        dispatch({
                          type: 'SET_NEWS_CURRENT_PAGE',
                          payload: page,
                        });
                      }}
                    />
                  </div>,
                ]
              : null}
          </QueueAnim>
        ) : (
          <Empty />
        )
      ) : (
        <Loading />
      )}
    </div>
  );
};

export default News;
